export const checkoutKeys = {
  prices: ['prices'],
  subscription: ['subscription'],
};

export const userKeys = {
  user: ['user'],
};

export const qrCodeStylesKeys = {
  qrCodeStyles: ['qrCodeStyles'],
};

export const qrCodeKeys = {
  qrCodeData: ['qrCodeData'],
  websiteQrData: ['websiteQrData'],
  vCardPlusQrData: ['vCardPlusQrData'],
  myQrsData: ['myQrsData'],
  couponQrData: ['couponQrData'],
  videoQrData: ['videoQrData'],
  qrCodeById: (id: number | string) => [...qrCodeKeys.qrCodeData, id],
  websiteQRDataById: (id: number | string) => [...qrCodeKeys.websiteQrData, id],
  vCardPlusQRDataById: (id: number | string) => [...qrCodeKeys.vCardPlusQrData, id],
  couponQRDataById: (id: number | string) => [...qrCodeKeys.couponQrData, id],
  videoQRDataById: (id: number | string) => [...qrCodeKeys.videoQrData, id],
};

export const folderKeys = {
  allFolders: ['allFolders'],
  folderById: (id: number | string) => [...folderKeys.allFolders, id],
};

export const statsKeys = {
  analytics: ['analytics'],
  full: (params: object) => [...statsKeys.analytics, 'full', params],
  scansByOperatingSystem: () => [...statsKeys.analytics, 'operating_system'],
  scansByCountry: () => [...statsKeys.analytics, 'country'],
  scansBy: () => [...statsKeys.analytics, 'by'],
  scansByCity: () => [...statsKeys.analytics, 'region/city'],
};
